export const CLEAR_ERROR_SAVING_SUBSCRIPTIONS = "CLEAR_ERROR_SAVING_SUBSCRIPTIONS";
export const FETCH_SUBSCRIPTIONS = "FETCH_SUBSCRIPTIONS";
export const FETCH_SUBSCRIPTIONS_FAILURE = "FETCH_SUBSCRIPTIONS_FAILURE";
export const FETCH_SUBSCRIPTIONS_SUCCESS = "FETCH_SUBSCRIPTIONS_SUCCESS";
export const SAVE_SUBSCRIPTIONS = "SAVE_SUBSCRIPTIONS";
export const SAVE_SUBSCRIPTIONS_FAILURE = "SAVE_SUBSCRIPTIONS_FAILURE";
export const SAVE_SUBSCRIPTIONS_SUCCESS = "SAVE_SUBSCRIPTIONS_SUCCESS";
